<ng-container *transloco="let t; read: 'blog'">
  <section class="teaser">
    <div class="teaser-pics">
      <div
        class="teaser teaser1 active"
        [ngStyle]="{ backgroundImage: images[0] }"
      ></div>
    </div>
    <div class="content">
      <div class="title">BLOG</div>
      <div class="sub">{{ t("subtitle") }}</div>
    </div>
  </section>

  <section class="headliner" *transloco="let t; read: 'blog-v260'">
    <h2>{{ t("overview-title") }}</h2>
    <div [innerHTML]="t('overview-content')"></div>
    <a [routerLink]="['/blog-version26']" class="call">{{
      t("overview-more")
    }}</a>
  </section>

  <section class="headliner" *transloco="let t; read: 'blog-v250'">
    <h2>{{ t("overview-title") }}</h2>
    <div [innerHTML]="t('overview-content')"></div>
    <a [routerLink]="['/blog-version25']" class="call">{{
      t("overview-more")
    }}</a>
  </section>

  <section class="headliner" *transloco="let t; read: 'blog-v240'">
    <h2>{{ t("overview-title") }}</h2>
    <div [innerHTML]="t('overview-content')"></div>
    <a [routerLink]="['/blog-version24']" class="call">{{
      t("overview-more")
    }}</a>
  </section>

  <section
    class="headliner"
    *transloco="let t; read: 'blog-import-from-pojects'"
  >
    <h2>{{ t("overview-title") }}</h2>
    <p>{{ t("overview-text") }}</p>
    <a [routerLink]="['/blog-import']" class="call">{{ t("overview-more") }}</a>
  </section>

  <section class="headliner">
    <h2>Bildgenaue Navigation in der Zeitleiste</h2>
    <p>
      Die Zeitleiste des Clip-Editors wurde um neue Schaltflächen und
      Tastaturkürzel zur bildgenauen Navigation ergänzt.
    </p>
    <a [routerLink]="['/blog-framenavigation']" class="call">Mehr</a>
  </section>
  <section class="headliner">
    <h2>Anbindung an externe Webservices</h2>
    <p>
      Durch die neue Möglichkeit, benutzerdefinierte Scripte als Aktionen an
      Elemente zu binden (z.&nbsp;B. nach dem Klick auf eine Schaltfläche)
      können externe Webservices eingebunden werden.
    </p>
    <a [routerLink]="['/blog-scriptaction']" class="call">Mehr</a>
  </section>
  <section class="headliner">
    <h2>Versionierung in video2manual</h2>
    <p>
      Mit der Version 2.2 bekommt video2manual die Funktion, Projekte mit
      Versionsnummern zu versehen. Dieser Beitrag zeigt, wie die Versionsnummern
      manuell oder automatisch vergeben und wozu sie genutzt werden können.
    </p>
    <a [routerLink]="['/blog-versioning']" class="call">Mehr</a>
  </section>
  <section class="headliner">
    <h2>Brose nutzt video2manual</h2>
    <p>
      Jens Makareinis von der Brose Fahrzeugteile GmbH & Co. KG berichtet von
      den Erfolgen durch die Einführung unserer Software video2manual und wie
      sie im Unternehmensalltag eingesetzt wird.
    </p>
    <a [routerLink]="['/blog-brose']" class="call">Mehr</a>
  </section>
  <hr />
  <section class="headliner">
    <h2>Clip-Nummern</h2>
    <p>
      Zur einfacheren Oritenierung und zur Unterstützung von Review-Prozessen
      bietet v2m die Möglichkeit, Clip-Nummern einzublenden.
    </p>
    <a [routerLink]="['/blog-clipnumber']" class="call">Mehr</a>
  </section>
  <hr />
  <section class="headliner">
    <h2>Metadaten nutzen</h2>
    <p>
      Metadaten reichern ein v2m-Projekt um zusätzliche Informationen an, die
      z.&nbsp;B. zur Steuerung der Anwendung oder zur Dokumentenlenkung genutzt
      werden können.
    </p>
    <a [routerLink]="['/blog-using-metadata']" class="call">Mehr</a>
  </section>
  <hr />
  <section class="headliner">
    <h2>Verwenden und Kombinieren unterschiedlicher Medien</h2>
    <p>
      v2m ermöglicht die Kombination von unterschiedlichen Quell-Medien, wie
      z.B. Real-Clips, Screen-Videos und Animationen.
    </p>
    <a [routerLink]="['/blog-sources']" class="call">Mehr</a>
  </section>
  <hr />
  <section class="headliner">
    <h2>Bild-Bibliothek</h2>
    <p>
      Durch die Verwendung gemeinsamer Bild-Bibliotheken kann eine
      Vereinheitlichung der Video-Anwendungen und damit auch eine Umsetzung des
      eigenen Corporate Designs erreicht werden.
    </p>
    <a [routerLink]="['/blog-image-library']" class="call"
      >t("overview-more")</a
    >
  </section>
  <hr />
  <section class="headliner">
    <h2>Export eines durchlaufenden Videos</h2>
    <p>
      Neben dem Publizieren als Video-Anleitung unterstützt video2manual auch
      die Ausgabe als durchlaufendes Video. Der Beitrag beschreibt, was dabei zu
      beachten ist und wie man die Ausgabe steuern kann.
    </p>
    <a [routerLink]="['/blog-export']" class="call">Mehr</a>
  </section>
  <hr />
  <section class="headliner">
    <h2>Publizierte Videoformate</h2>
    <p>
      Beim Publizieren stehen zwei Videoformate zur Auswahl (MP4 und WebM).
      Unterschiedliche Browser unterstützen unterschiedliche Videoformate.
      Welches Format wann die richtige Wahl ist, wird in diesem Beitrag
      beschrieben.
    </p>
    <a [routerLink]="['/blog-videoformat']" class="call">Mehr</a>
  </section>
  <hr />
  <section class="headliner">
    <h2>Verzeichnisse einlesen vs. Menü erstellen</h2>
    <p>
      Beim Start eines neuen Projekts stehen zwei Möglichkeiten zur Verfügung:
      Verzeichnis einlesen und Menü erstellen. Dieser Beitrag soll die Vor- und
      Nachteile der beiden Methoden gegenüberstellen.
    </p>
    <a [routerLink]="['/blog-readdirectory']" class="call">Mehr</a>
  </section>
</ng-container>
